import { makeStyles } from '@material-ui/core/styles';
import bg from "../assets/images/bg_small.jpg"
import bgDarkPurple from "../assets/images/bg_small_purple.png"

export const useStyles = makeStyles(theme => ({
  hero: {
    position: "relative",
    backgroundImage:  `url(${bg}), linear-gradient(to top, ${theme.palette.darkPurple} 0%, ${theme.palette.darkPurple} 100%)`,
    backgroundBlendMode: 'soft-light',
    paddingBottom: "2.5rem",
    [`${theme.breakpoints.between(theme.breakpoints.values.md, theme.breakpoints.values.xl)} and (orientation: landscape)`]:{
      backgroundImage:  `url(${bgDarkPurple})`,
      backgroundBlendMode: 'initial',
    },
  },
  heroWrapper: {
    width: "100%",
    height: "0",
    maxWidth: theme.limits.lg,
    margin: '0 auto',
    paddingBottom: "155%",
    position: "relative",
    [theme.breakpoints.up('md')]: {
      paddingBottom: "50%"
    },
    [theme.breakpoints.up('lg')]: {
      paddingBottom: "42%"
    },
    [theme.breakpoints.up('xl')]: {
      paddingBottom: "42%"
    },
  },
  heroImage: {
    width: "100%",
    position: "absolute"
  },
  divider: {
    position: "absolute",
    bottom: "0",
    width: "100%",
  },
  dividerMargin: {
    backgroundColor: theme.palette.yellow,
    height: "4rem",
    marginBottom: "0"
  }
}));
